<ion-header>
	<app-main-header></app-main-header>
</ion-header>

<ion-content class="no-padding">
	<ion-list>
		<ion-card class="duelist_card" *ngIf="duelists.length === 0">
			<ion-card-content>
				<p>Noch keine Duelle durchgeführt</p>
			</ion-card-content>
		</ion-card>
		<ion-card class="duelist_card" *ngFor="let item of duelists">
			<ion-card-content>
				<p>{{ item.username }}</p>
				<ion-button size="small" (click)="challengeDuelist(item)">Herausfordern</ion-button>
			</ion-card-content>
		</ion-card>
	</ion-list>
</ion-content>
